import React, { useState, useEffect, useRef } from 'react';
import style from './ErrorReport.module.css';
import { useNavigate } from 'react-router-dom';
import ImageFileAttach from '../../../../components/box/ImageFileAttach';
import Modal from '../../../../components/comm/Modal';
import ToastPopup from '../../../../components/comm/ToastPopup';
import HeadSub from '../../../../components/comm/HeadSub';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

const ErrorReport = () => {

    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);    //모달창
    const [isCompleteOpen, setIsCompleteOpen] = useState(false);    //완료 모달창

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    /* 글자수 세기 */
    let [textCount, setTextCount] = useState(0);
    const [errorMessage, setErrorMessage] = useState(''); // 메시지
    const [feedback, setFeedback] = useState(''); // 피드백 여부

    const onTextHandler = (e) => {
        let newValue = e.target.value.slice(0, 500);
        setErrorMessage(newValue);
        setTextCount(newValue.length);
    };


    const onFeedbackChange = (e) => {
        setFeedback(e.target.value);
    };

    const imageFileAttachRef = useRef();

    const saveBbs = async () => {
        const url = "/notices/saveBbs";
        const jToken = localStorage.getItem("jToken");

        const imagesToUpload = imageFileAttachRef.current ? imageFileAttachRef.current.getImages() : [];
        console.log("Images to upload:", imagesToUpload);

        const formData = new FormData();
        formData.append('nttCn', errorMessage);
        formData.append('answrUseAt', feedback);

        imagesToUpload.forEach((file, idx) => {
            formData.append('files_' + idx, file);
        });

        try {
            const res = await axiosApi.post(url, formData, {
                headers: {
                    "Authorization" : `Bearer ${jToken}`
                    , 'Content-Type': 'multipart/form-data'
                },
            });

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                console.log('✅ 서버 전송 성공');
                setIsCompleteOpen(true);
                //alert('오류 제보가 성공적으로 접수되었습니다.');
                //navigate(-1);
            } else {
                console.log('🚫 서버 전송 실패:', res.data.resultMsg);
                //alert('오류 제보에 실패했습니다. 다시 시도해주세요.');
                setToastMessage('오류 제보에 실패했습니다.\n 다시 시도해주세요.')
                setToast(true);
            }
        } catch (err) {
            console.error("오류 제보 서버 전송 중 오류:", err);
            // alert('오류 제보 중 문제가 발생했습니다. 네트워크 상태를 확인하거나 잠시 후 다시 시도해주세요.');
            setToastMessage('네트워크 상태를 확인하거나 \n 잠시 후 다시 시도해주세요.')
            setToast(true);
            throw err;
        }

        setIsOpen(false);
    };


    //카카오 채널 이동
    const handleOnJoinMeeting = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    }

    return (
        <>
            <HeadSub title="오류 제보" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-side-padding="0">

                    <div className={style['content-box']}>
                        <div className={style['tit-box']}>
                            <p>오류 내용</p>
                            <span>오류 이미지를 첨부해주시면 오류 해결에 큰 도움이 됩니다.</span>
                        </div>
                        <div className={style['img-file-box']}>
                            <ImageFileAttach ref={imageFileAttachRef} />
                        </div>
                        <div className={style["textarea-Box"]}>
                            <div className={style['custom-textarea']}>
                                <textarea
                                    maxLength='500'
                                    onChange={onTextHandler}
                                    className='scroll'
                                    data-scroll-type="b"
                                    value={errorMessage}
                                >
                                </textarea>
                            </div>
                            <div className={style["txt-count"]}>{textCount} / 500</div>
                        </div>

                        <div className={style['bot-box']}>
                            <p>피드백 수신 여부</p>
                            <span>오류 해결 후 안내를 드릴까요? <br />
                                회원정보에 등록된 휴대전화번호로 문자 또는 전화 안내를 드립니다.
                            </span>
                            <div className={style['select-list-box']}>
                                <ul>
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input
                                                type="radio"
                                                id="feedback1"
                                                name='feedback-select'
                                                value="0"
                                                checked={feedback === '0'}
                                                onChange={onFeedbackChange}
                                            />
                                            <label htmlFor="feedback1">
                                                <span>아니요, 괜찮아요</span>
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input
                                                type="radio"
                                                id="feedback2"
                                                name='feedback-select'
                                                value="1"
                                                checked={feedback === '1'}
                                                onChange={onFeedbackChange}
                                            />
                                            <label htmlFor="feedback2">
                                                <span>네, 받을래요</span>
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div className={style['list-box']}>
                                <ul>
                                    <li>
                                        <span>제보 해주시는 오류들은 순차적으로 검토 후 처리됩니다.</span>
                                    </li>
                                    <li>
                                        <span>보다 빠른 오류 처리가 필요한 경우 케어플러스 고객센터로 문의해주세요.</span>
                                    </li>
                                </ul>
                            </div>

                            <button className={style['notic-box']} onClick={()=> handleOnJoinMeeting('https://pf.kakao.com/_xlvxeHn/chat')}>
                                <div className={style['icon-box']}>
                                    <div className={style['icon']}>
                                        <span className='blind'>카카오톡 채팅상담</span>
                                    </div>
                                </div>
                                <div className={style['notic-txt-box']}>
                                    <p className={style['top-p']}>
                                        <b>케어플러스</b>카카오채널 상담
                                    </p>
                                    <p className={style['bot-p']}>
                                        <span><b>평일</b> 09:00~17:00</span><i>/</i>
                                        <span><b>점심시간</b> 12:00~13:00</span>
                                    </p>
                                </div>
                            </button>


                        </div>
                    </div>

                    <div className="bottom-fixed-box" data-border-line="top">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1">
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=> setIsOpen(true)} disabled={textCount === 0 || feedback === ''}>
                                    <span>제보 하기</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>오류를 제보하시겠어요?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={()=>setIsOpen(false)}>
                                <span>아니요</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={saveBbs}>
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={isCompleteOpen} setIsOpen={setIsCompleteOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>오류 제보가 완료되었습니다.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={()=> { setIsCompleteOpen(false); navigate(-1)}}>
                                <span>확인</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>


            {/* 토스트 */}
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position='center'
                />
            )}
        </>
    );
};

export default ErrorReport;
